<template>
  <div>
    <p class="text-sm mb-4">Détail des coûts de la facture</p>
    <ClaimCostItemsEditor
      v-model:editing="editing"
      :costs="invoice.costs"
      :editable="editable"
      :saving="saving"
      @save="save"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ClaimCostItemsEditor from "@/components/claim/details/ClaimCostItemsEditor.vue";

export default {
  props: ["invoice"],

  components: {
    ClaimCostItemsEditor,
  },

  emits: ["updated"],

  data() {
    return {
      editing: false,
      saving: false,
    };
  },

  computed: {
    editable() {
      return this.invoice.approvalStatus === "to_be_approved";
    },
  },

  methods: {
    ...mapActions("claims", ["updateInvoiceCostItems"]),

    async save(costItems) {
      this.saving = true;
      const response = await this.updateInvoiceCostItems({ invoiceId: this.invoice.id, costItems });
      this.saving = false;

      if (!response?.success) return;

      this.editing = false;
      this.$emit("updated");
    },
  },
};
</script>
